import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CurrentLocationDto } from 'api';
import FilledGeopin from 'assets/volvoIcons/Positioning/Geopin';
import { Status, statusTranslationMapping } from 'domain/constants/status';
import {
	TextDisplay,
	TextDisplayProps,
} from 'library/components/controls/display/TextDisplay';
import { getLocalizedDateFormat } from 'library/formatters/DateFormatter';
import { LocationCountryText } from 'modules/Shared/Components/OperatingLocation/LocationCountryText';

interface CountryCityDisplayProps {
	currentLocation?: CurrentLocationDto | null;
	withHelperText?: boolean;
	loading?: TextDisplayProps['loading'];
}

export const CountryCityDisplay = ({
	currentLocation,
	withHelperText = true,
	loading,
}: CountryCityDisplayProps): React.JSX.Element => {
	const { t } = useTranslation(['commonStatus', 'commonUnit']);
	const helperText = useMemo(() => {
		if (!withHelperText || !currentLocation) {
			return '';
		}
		const { updateEvent, utcUpdateDate } = currentLocation;
		const eventTrans =
			updateEvent && statusTranslationMapping[updateEvent as Status]
				? t(statusTranslationMapping[updateEvent as Status])
				: updateEvent || '';

		return `${eventTrans} ${getLocalizedDateFormat(utcUpdateDate)}`;
	}, [t, currentLocation, withHelperText]);

	return (
		<TextDisplay
			label={t('commonUnit:location')}
			loading={loading}
			value={
				<LocationCountryText
					countryCode={currentLocation?.country}
					city={currentLocation?.city}
				/>
			}
			helperText={helperText}
			startIcon={currentLocation ? null : <FilledGeopin />}
		/>
	);
};
